import { Users, Crown, MessagesSquare, TrendingUp, Megaphone, Ticket, Handshake, GraduationCap, FileSignature, ShieldCheck, Gem } from "lucide-react";

export const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_03d2330b-dd81-4c2c-809a-f5bf247e446d/artifacts/438ddf889a04bb8c_5E11608C-3B2B-4286-A225-C125661FE4F5.jpeg";

export const NAV_LINKS = [
  { label: "Services", href: "#services", testid: "nav-services-link" },
  { label: "Menu", href: "#menu", testid: "nav-menu-link" },
  { label: "About", href: "#about", testid: "nav-about-link" },
  { label: "Contact", href: "#contact", testid: "nav-contact-link" },
];

export const SERVICES = [
  {
    id: "networking-events",
    index: "01",
    icon: Users,
    title: "Member Networking Events",
    description:
      "Exclusive invitations to kickbacks, mixers, and after-hours events provide an opportunity to connect with a diverse group of discreet adults from various industries.",
  },
  {
    id: "a-list-meets",
    index: "02",
    icon: Crown,
    title: "Private A-List Meets",
    description:
      "Discreet, hand-matched connections — built for your preferences, not ours.",
  },
  {
    id: "curated-chats",
    index: "03",
    icon: MessagesSquare,
    title: "Curated High-Trust Chats",
    description:
      "Our exclusive circles and moderated discussions cater to both individual and group preferences.",
  },
  {
    id: "earn-online",
    index: "04",
    icon: TrendingUp,
    title: "Earn Over $5,000 Monthly Online",
    description:
      "We offer comprehensive training to guide you in establishing a profitable online business that generates over $5,000 monthly. Our program guarantees business growth and the potential for additional income, or a full refund.",
  },
];

export const MENU = [
  {
    id: "promotional-offer",
    icon: Megaphone,
    title: "Promotional Offer",
    items: [
      { name: "Repost", price: "$24.99" },
      { name: "Quote Post", price: "$49.99" },
      { name: "Pinned Post", price: "$99.99" },
    ],
  },
  {
    id: "chats",
    icon: MessagesSquare,
    title: "Chats",
    items: [
      { name: "One Month Group", price: "$9.99" },
      { name: "Six Months Group", price: "$24.99" },
      { name: "One Year Group", price: "$44.99" },
      { name: "Solo Custom", price: "$99.99" },
    ],
  },
  {
    id: "events",
    icon: Ticket,
    title: "Events",
    items: [
      { name: "One Event Pass", price: "$69.99" },
      { name: "Three Event Pass", price: "$119.99" },
      { name: "Full Year Pass", price: "$299.99" },
      { name: "VIP Global + Bring Extra Guest", price: "$399.99" },
    ],
  },
  {
    id: "meetings",
    icon: Handshake,
    title: "Meetings",
    items: [{ name: "Private meetings", price: "Start at $99.99" }],
    note: "Prices vary based on client preferences.",
  },
  {
    id: "courses-and-more",
    icon: GraduationCap,
    title: "Courses, Websites & More",
    items: [
      { name: "Courses, websites, logo designs, and more", price: "$249.99 and up" },
    ],
  },
];

export const ENQUIRY_SERVICES = [
  ...SERVICES.map((s) => s.title),
  ...MENU.map((m) => m.title),
  "Other",
];

export const FEATURES = [
  {
    id: "nda",
    icon: FileSignature,
    title: "Private and Safe for Members (NDA's)",
    description:
      "We prioritize the privacy and security of our members by adhering to strict non-disclosure agreements.",
  },
  {
    id: "fraud-protection",
    icon: ShieldCheck,
    title: "Fraud Protection on Payments",
    description:
      "We implement robust fraud protection measures for all payment transactions. Third-party apps are only allowed to process payments after verification.",
    pills: ["CashApp", "Zelle", "Venmo", "Chime", "Apple Pay", "Revolut", "BTC Coinbase", "and many others"],
  },
  {
    id: "memberships",
    icon: Gem,
    title: "Memberships for Free Services",
    description:
      "We offer memberships for our services, ensuring that our members can access a wide range of features without any hassle.",
  },
];

export const REVIEWS = [
  {
    name: "Marcus T.",
    service: "Member Networking Events",
    quote:
      "The kickback in LA was worth every penny. I met amazing people and made real connections. Nothing about it felt forced.",
  },
  {
    name: "Danielle R.",
    service: "Private A-List Meets",
    quote:
      "They matched me with exactly the kind of people I asked for. Discreet, professional, and zero small talk. The NDA process made me feel safe from day one.",
  },
  {
    name: "Kwame O.",
    service: "Curated High-Trust Chats",
    quote:
      "The group chat alone pays for itself. Real answers from real operators, any time of night. I joined for a month and stayed for the year.",
  },
  {
    name: "Sofia L.",
    service: "Earn Over $5,000 Monthly Online",
    quote:
      "I was skeptical about the income course, but the training is step-by-step and the support team actually responds. Cleared my first $5K month in ninety days.",
  },
  {
    name: "James W.",
    service: "Events",
    quote:
      "Bought the three event pass, upgraded to the full year within a month. Every event has been organized, secure, and full of quality people.",
  },
  {
    name: "Priya N.",
    service: "Promotional Offer",
    quote:
      "The pinned post put my page in front of hundreds of thousands. My bookings doubled the same week. Easiest marketing money I've ever spent.",
  },
];

export const LOCATIONS = {
  hometown: "Los Angeles",
  blurb:
    "Our hometown is Los Angeles, and we serve all over the United States and a few countries outside of it.",
  countries: ["United States", "Canada", "United Kingdom", "Nigeria", "Mexico", "and a few other countries"],
};

export const PROCESS_STEPS = [
  {
    index: "01",
    text: "Contact us with your inquiry so we can provide you with a solution.",
  },
  {
    index: "02",
    text: "Please respect all administrators and provide us with accurate information so that we can best serve you.",
  },
  {
    index: "03",
    text: "Complete the NDA process and membership process before receiving any services.",
  },
];

export const TERMS_SECTIONS = [
  {
    id: "all-sales-final",
    title: "All Sales Final",
    text: "We do not offer refunds. All sales are final and are not eligible for refunds or store credits.",
  },
  {
    id: "nda-membership",
    title: "NDA & Membership",
    text: "Complete the NDA process and membership process before receiving any services. We prioritize the privacy and security of our members by adhering to strict non-disclosure agreements.",
  },
  {
    id: "conduct",
    title: "Conduct & Accurate Information",
    text: "Please respect all administrators and provide us with accurate information so that we can best serve you.",
  },
  {
    id: "payments",
    title: "Payments & Fraud Protection",
    text: "We implement robust fraud protection measures for all payment transactions. Third-party apps are only allowed to process payments after verification.",
  },
];

export const STATS = [
  { value: "600K+", label: "Followers worldwide" },
  { value: "50+", label: "Events hosted" },
  { value: "50M+", label: "Views and counting" },
  { value: "98%", label: "Member return rate" },
];

export const CONTACT = {
  email: "inculillin@gmail.com",
  phone: "Private",
  office: "Executive LV office · By appointment only",
};

export const SOCIALS = [
  { label: "X", href: "https://www.x.com/DAHSupportX", testid: "contact-social-x-link" },
  { label: "Telegram", href: "https://t.me/verifiedadminincu", testid: "contact-social-telegram-link" },
];
